import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from "react";

const PanelActionsContext = createContext(null);

export function PanelActionsProvider({ registerActions, children }) {
  const value = useMemo(
    () => ({
      registerActions,
    }),
    [registerActions]
  );

  return (
    <PanelActionsContext.Provider value={value}>
      {children}
    </PanelActionsContext.Provider>
  );
}

export function usePanelActions(actions = []) {
  const context = useContext(PanelActionsContext);
  const actionsRef = useRef(actions);

  actionsRef.current = actions;

  const signature = actions
    .map((action) =>
      [
        action.key,
        action.icon,
        action.label,
        Boolean(action.disabled),
      ].join(":")
    )
    .join("|");

  useEffect(() => {
    if (!context?.registerActions) {
      return undefined;
    }

    const registeredActions = actionsRef.current.map((action) => ({
      ...action,
      onClick: (...args) => {
        const currentAction = actionsRef.current.find(
          (candidate) => candidate.key === action.key
        );

        return currentAction?.onClick?.(...args);
      },
    }));

    context.registerActions(registeredActions);

    return () => {
      context.registerActions([]);
    };
  }, [context, signature]);
}
